import { Link } from "react-router-dom";
import { Seo } from "@/components/layout/Seo";
import { useLang } from "@/context/LanguageContext";

export function PrivacyPage() {
  const { t } = useLang();
  return (
    <>
      <Seo page="home" />
      <section className="py-14 md:py-20" data-testid="privacy-page">
        <div className="max-w-3xl mx-auto px-6 md:px-12">
          <h1 className="font-display text-4xl md:text-5xl tracking-tight text-navy">{t.privacyPage.title}</h1>
          <p className="mt-8 text-base md:text-lg leading-relaxed text-navy/70">{t.privacyPage.text}</p>
        </div>
      </section>
    </>
  );
}

export default function NotFoundPage() {
  const { lang, t } = useLang();
  return (
    <>
      <Seo page="home" noindex />
      <section className="py-20 md:py-28 text-center" data-testid="not-found-page">
      <h1 className="font-display text-5xl md:text-6xl tracking-tight text-navy">404</h1>
      <p className="mt-4 text-navy/60">{t.notFound.title}</p>
      <Link
        to={`/${lang}`}
        data-testid="not-found-home-link"
        className="mt-8 inline-block bg-navy text-white text-sm font-medium px-8 py-3 hover:bg-ser-purple transition-colors"
      >
        {t.notFound.link}
      </Link>
      </section>
    </>
  );
}
